exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2d0cb869!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/org/OrgUser.vue
// module id = 575
// module chunks = 2